import { combineReducers } from 'redux';
// Import reducers
import table from './main_availability_table_reducer';
import form from './main_availability_form_reducer';

export default combineReducers({
	table,
	form
});
